const MoneyCard = ({ label, info, color }) => {
    return (
        <div className={`header-card h-full`} style={{ backgroundColor: color }}>
            <p className="header-card-label mb-0 mt-0 md:mb-[10px] md:mt-[15px] text-[13px]">{label}</p>
            <p className="header-card-info text-[18px] mb-[15px] md:mt-0 md:mb-[10px] md:text-[22px]">{info}</p>
        </div>
    )
}

export default MoneyCard;